import { defineStore } from 'pinia'
import { usePodStore } from './PodStore.js';
import Api from '../api/Api'

function changeComment(comment) {
  if (comment.start !== null) comment.start /= 1000;
  if (comment.end !== null) comment.end /= 1000;
  return comment;
}

function sortSubtitles(a, b) {
  if (a.start < b.start) return -1;
  if (a.start > b.start) return 1;
  return 0;
}

export const usePodCommentStore = defineStore('podComment', {
  state: () => ({
    comments: [],
    closeForms: null,
    visibleForms: 0,
  }),
  getters: {
    getComments: function(state) {
      // return state.comments;
      return function(parentID) {
        return state.comments.filter(x => x.parentid == parentID);
      }
    },
    getCommentsCount: function(state) {
      return state.comments.length;
    },
    getCloseFormsEvent: function(state) {
      return state.closeForms;
    },
    getVisibleForms: function(state) {
      return state.visibleForms;
    },
  },
  actions: {
    promptRefreshComments: function(podID) {
      const podStore = usePodStore();
      const viewPod = podStore.getViewPod;

      if (viewPod && viewPod.id && viewPod.id == podID) {
        this.refreshComments(podID);
      }
    },

    refreshComments: async function(podID) {
      const response = await Api.comment.getComments(podID);

      this.comments = response.data.map(changeComment);
      this.comments.sort(sortSubtitles);
      return response.data;
    },

    resetComments: function() {
      this.comments = [];
    },

    createComment: async function(data) {
      const response = await Api.comment.createComment(data.podID, data.payload);
      // console.log("Created comment", response);
      return response;
    },

    updateComment: async function(data) {
      const response = await Api.comment.updateComment(data.podID, data.commentID, data.payload);
      // console.log("comment updated", response);
      return response;
    },

    deleteComment: async function(comment) {
      const response = await Api.comment.deleteComment(comment.podid, comment.id);
      // console.log("deleted comment response", response);
      return response;
    },

    submitComments: function(data) {
      return Api.comment.submitComments(data.podId, data.payload);
    },

    getCommentsStateless: async function(podID) {
      const response = await Api.comment.getComments(podID);
      return response.data;
    },

    likeComment: async function(data) {
      await Api.comment.likeComment(data.podId, data.payload.commentId);

      const index = this.comments.findIndex((obj) => obj.id === data.payload.commentId);

      if (index >= 0) {
        this.comments[index].likesCount++;
        this.comments[index].likedBy.push(data.payload.userId);
      }
    },

    dislikeComment: async function(data) {
      await Api.comment.dislikeComment(data.podId, data.payload.commentId);

      const index = this.comments.findIndex((obj) => obj.id === data.payload.commentId);

      if (index >= 0) {
        this.comments[index].likesCount--;

        const newCollection = this.comments[index].likedBy.filter((id) => id !== data.payload.userId);
        this.comments[index].likedBy = newCollection;
      }
    },

    checkComment: async function(data) {
      await Api.comment.checkComment(data.podId, data.payload.commentId);

      const index = this.comments.findIndex((obj) => obj.id === data.payload.commentId);

      if (index >= 0) {
        this.comments[index].checked = true;
      }
    },

    uncheckComment: async function(data) {
      await Api.comment.uncheckComment(data.podId, data.payload.commentId);

      const index = this.comments.findIndex((obj) => obj.id === data.payload.commentId);

      if (index >= 0) {
        this.comments[index].checked = false;
      }
    },

    setCloseFormsEvent: function(value) {
      this.closeForms = value;
    },
    increaseVisibleForms: function() {
      this.visibleForms = this.visibleForms + 1;
    },
    decreaseVisibleForms: function() {
      this.visibleForms = this.visibleForms - 1;
    },
  },
});
